import { demographicConstants } from '../../_constants';
import swal from 'sweetalert2';

const initialState = { updateOrDeleteDemographicDataLoading: true, data: '', error: false };

export function updateOrDeleteDemographicData(state = initialState, action) {

    switch (action.type) {
        case demographicConstants.REQUEST_UPDATE_DELETE_DEMOGRAPHIC_DATA:
            return {
                updateOrDeleteDemographicDataLoading: true,
                data: '',
                error: false
            };
        case demographicConstants.RECIEVE_UPDATE_DELETE_DEMOGRAPHIC_DATA:
            swal({
                text: 'Successfully Updated',
                type: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
            })
            return {
                updateOrDeleteDemographicDataLoading: false,
                data: action.demographicData,
                error: false,
            };
        case demographicConstants.ERROR_UPDATE_DELETE_DEMOGRAPHIC_DATA:
            return {
                updateOrDeleteDemographicDataLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/demographicData/updateOrDeleteDemographicData.reducer.js